import React, { useState } from 'react';
import styled from 'styled-components';

const FloatingLangSwitch: React.FC = () => {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';
  const current = path.startsWith('/en') ? 'en' : path.startsWith('/he') ? 'he' : 'ar';
  const [open, setOpen] = useState(false);

  const langs = [
    { code: 'ar', label: 'AR', href: '/' },
    { code: 'en', label: 'EN', href: '/en' },
    { code: 'he', label: 'HE', href: '/he' },
  ];

  const others = langs.filter(l => l.code !== current);
  const currentLabel = langs.find(l => l.code === current)!.label;

  return (
    <Wrapper>
      {open && (
        <>
          {others.map(lang => (
            <OtherBtn key={lang.code} href={lang.href} onClick={() => setOpen(false)}>
              {lang.label}
            </OtherBtn>
          ))}
        </>
      )}
      <ActiveBtn
        onClick={() => setOpen(o => !o)}
        aria-label="Switch language"
        aria-expanded={open}
      >
        {currentLabel}
      </ActiveBtn>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  bottom: 92px;
  right: 28px;
  z-index: 10001;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 6px;
`;

const ActiveBtn = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #DA015C;
  color: #fff;
  font-weight: 800;
  font-size: 0.82rem;
  border: 2px solid #fff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
  &:hover {
    background: #b8004e;
    transform: scale(1.08);
  }
`;

const OtherBtn = styled.a`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #000;
  color: #fff;
  font-weight: 800;
  font-size: 0.78rem;
  border: 2px solid rgba(255,255,255,0.3);
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
  &:hover {
    background: #DA015C;
    transform: scale(1.08);
  }
`;

export default FloatingLangSwitch;
